import Constants from '../definitions/constants';
import { intl } from '../locales/localesConfig';

const LocaleTooling = {
  getCalculationUnitContextLocale: (localeText) => {
    if(typeof localeText != "string") {
      localeText =  intl.formatMessage({ id: localeText.props.id, values: localeText.props.values});
    }
    let context = "employee";
    Object.keys(Constants.language.calculationUnitTranslations).forEach((item) => {
      if(localeText.includes("$"+item+"$")) {
        localeText = localeText.replace(new RegExp("\\$" + item + "\\$", "g"), intl.formatMessage({ id: "common.calculationUnitTranslations." + context + "." + item }));
      }
    })
    return localeText;
  }
};

export default LocaleTooling;


// WEBPACK FOOTER //
// ./source/tooling/localeTooling.js